<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row mb-3">
                <div
                  class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center"
                  >
                  <router-link
                    class="
                      btn btn-primary btn-md
                      font-weight-semibold
                      btn-py-2
                      px-4
                    "
                    :to="{ name: 'AddBlog' }"
                    >+ {{ translations.addBlog }}</router-link
                  >
                  <treeselect
                    v-model="b2bOrb2c"
                    class="w-25 mx-1 form-control form-control-modern"
                    :options="b2bOrb2cOptions"
                    placeholder="B2B/B2C"
                  />
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dataTables_wrapper dt-bootstrap5 no-footer" v-if="list.length > 0">
              <div class="table-responsive">
                <table
                  class="
                    table table-ecommerce-simple table-striped
                    mb-0
                    dataTable
                    no-footer
                  "
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Naslov</th>
                      <th class="sorting">Redoslijed</th>
                      <th class="sorting">Kratak opis</th>
                      <th class="sorting">Vidljivo na webu</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(blog, index) in list"
                      :key="blog.id"
                      @click="openDetails(blog.id)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="blog.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                      
                          <strong>{{ ((pager.currentPage - 1) * (searchConfig.pageSize)) + index + 1 }}</strong>
                      </td>
                      <td>
                          <strong>{{ blog.title }}</strong>
                      </td>
                      <td @click.stop>
                        <div class="order-cell">
                          <div class="order-badges">
                            <span
                              v-if="isB2B(blog)"
                              class="order-badge"
                              title="Redoslijed prikaza B2B"
                            >
                              <span class="order-badge-label">B2B</span>
                              <span class="order-badge-value">{{ blog.displayOrder }}</span>
                            </span>
                            <span
                              v-if="isB2C(blog)"
                              class="order-badge"
                              title="Redoslijed prikaza B2C"
                            >
                              <span class="order-badge-label">B2C</span>
                              <span class="order-badge-value">{{ blog.displayOrderB2C }}</span>
                            </span>
                          </div>
                          <i
                            class="bx bx-pencil order-edit"
                            role="button"
                            title="Izmijeni redoslijed"
                            @click.stop="openOrderModal(blog)"
                          ></i>
                        </div>
                      </td>
                      <td>
                        <div v-html="blog.shortDescription"></div>
                      </td>
                      <td>
                        <span
                          class="badge text-2"
                          :class="{
                            'text-success bg-soft-success': blog.isVisibleOnWeb,
                            'text-danger bg-soft-danger': !blog.isVisibleOnWeb
                        }">
                          {{ blog.isVisibleOnWeb? 'Da' : 'Ne' }}
                        </span>
                      </td>
                      <td>{{ formatDate(blog.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
                </div>
              </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
                        {{ translations.apply }}
                      </button>
                      
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" :pagination-props="paginationProps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header"><strong>{{ translations.deleteSelected }}</strong></h5>
      <div slot="body">
        <span v-html="modalText">
        </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction" data-bs-dismiss="modal">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="order-modal">
      <h5 slot="header">
        <strong>Izmjena redoslijeda prikaza</strong>
      </h5>
      <div slot="body">
        <div v-if="orderEdit">
          <p class="mb-3">
            <strong>{{ orderEdit.title }}</strong>
          </p>
          <div class="form-group mb-3" v-if="isB2B(orderEdit)">
            <label class="mb-1">Redoslijed prikaza B2B</label>
            <input
              type="number"
              min="1"
              class="form-control form-control-modern"
              v-model.number="orderB2B"
            />
          </div>
          <div class="form-group" v-if="isB2C(orderEdit)">
            <label class="mb-1">Redoslijed prikaza B2C</label>
            <input
              type="number"
              min="1"
              class="form-control form-control-modern"
              v-model.number="orderB2C"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              :disabled="savingOrder"
              @click.prevent.stop="saveOrder"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations, pager } from '@/mixins';
import api from '@/services/api';
import Pagination from '../shared/Pagination.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'Blogs',
  components: { Treeselect, Pagination, Modal },
  mixins: [translations, pager],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getBlogs',
      deleteActionName: 'deleteBlogs',
      bulkActionName: 'deleteBlogs',
      b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
      orderEdit: null,
      orderB2B: null,
      orderB2C: null,
      savingOrder: false,
    };
  },
  computed: {
    list() {
      return this.$store.getters.getBlogs;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    b2bOrb2cOptions() {
      return [
        {
          id: 'b2b',
          label: 'B2B',
        },
        {
          id: 'b2c',
          label: 'B2C',
        },
        {
          id: 'all',
          label: 'Sve',
        },
      ];
    },
    paginationProps() {
      return {
        b2b: this.b2bOrb2c === 'b2b' ? true : null,
        b2c: this.b2bOrb2c === 'b2c' ? true : null,
      };
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditBlog', params: { id: id } });
    },
    isB2B(blog) {
      // 1 = B2B, 3 = Sve
      return blog.blogContentType == 1 || blog.blogContentType == 3;
    },
    isB2C(blog) {
      // 2 = B2C, 3 = Sve
      return blog.blogContentType == 2 || blog.blogContentType == 3;
    },
    openOrderModal(blog) {
      this.orderEdit = blog;
      this.orderB2B = blog.displayOrder;
      this.orderB2C = blog.displayOrderB2C;
      $('#order-modal').modal('show');
    },
    async saveOrder() {
      if (this.savingOrder || !this.orderEdit) return;
      this.savingOrder = true;

      try {
        // Dohvati kompletnu vijest kako bi se pri spremanju sačuvala sva
        // postojeća polja, a promijenio samo redoslijed prikaza.
        const { data } = await api.getBlog(this.orderEdit.id);
        const blog = data.data;

        const formData = new FormData();
        formData.append('id', blog.id);
        formData.append('title', blog.title || '');
        formData.append('description', blog.description || '');
        formData.append('shortDescription', blog.shortDescription || '');
        formData.append('isVisibleOnWeb', blog.isVisibleOnWeb || false);
        formData.append('displayAuthorName', blog.displayAuthorName || false);
        formData.append('blogContentType', blog.blogContentType);
        formData.append('visibleFrom', blog.visibleFrom);
        formData.append('displayOrder', this.orderB2B || blog.displayOrder || 0);
        formData.append('displayOrderB2C', this.orderB2C || blog.displayOrderB2C || 0);

        await api.updateBlog(formData);

        this.$toast.info('Redoslijed prikaza je uspješno ažuriran.');
        $('#order-modal').modal('hide');
        this.orderEdit = null;
        this.$store.dispatch(this.actionName, {
          ...this.searchConfig,
          ...this.paginationProps,
        });
      } catch (e) {
        this.$toast.error('Došlo je do greške prilikom ažuriranja redoslijeda prikaza.');
      } finally {
        this.savingOrder = false;
      }
    },
    getBlogs() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  watch: {
    b2bOrb2c() {
      this.getBlogs();
    },
  },
};
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}

.order-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.order-badges {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-badge {
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: #212529;
}

.order-badge-label {
  padding: 3px 6px;
  background-color: #eceff3;
  color: #5a6570;
}

.order-badge-value {
  min-width: 26px;
  padding: 3px 8px;
  text-align: center;
  background-color: #fff;
}

.order-edit {
  cursor: pointer;
  font-size: 18px;
  color: #0088cc;
  flex-shrink: 0;
}

.order-edit:hover {
  color: #005f8c;
}
</style>

<style>
.vue-treeselect__placeholder {
  color: #000;
}

.form-control.form-control-modern.vue-treeselect.vue-treeselect--open-below.vue-treeselect--searchable.vue-treeselect--single.w-25 {
  height: 46px;
}

.vue-treeselect__control {
  border: none;
  background: none;
}
</style>